export default "__VITE_ASSET__DPj6bqWu__"